import React from "react";
import Navbar from "../Nav";

const Header = () => {
  return (
      <Navbar />
  );
};

export default Header;
